import React from 'react';
import Vector1 from "../../img/Vector1.png";
import Vector2 from "../../img/Vector2.png";
import me from "../../img/me.png";
import FloatinDiv from "../FloatingDiv/FloatingDiv";
import Github from "../../img/github.png";
import LinkedIn from "../../img/linkedin.png";
import Instagram from "../../img/instagram.png";
import thumbup from "../../img/thumbup.png";
import crown from "../../img/crown.png";
import glassesimoji from "../../img/glassesimoji.png";
import {motion} from "framer-motion";
import "./intro.scss"

const Intro = () => {
    const transition = {duration: 2, type: "spring"};

    return (
        <div className="intro">
            <div className="i-left">
                <div className="i-name">
                    <span>Hi! I am</span>
                    <span>Ozodbek</span>
                    <span>Experienced in front-end development for 3 years, I specialize in React and TypeScript. Proficient in JavaScript, I've honed expertise in creating responsive web applications. I leverage tools like Webpack, Docker to streamline development processes, ensuring efficiency. I'm currently exploring TensorFlow and NumPy, aiming to expand into deep learning development. My dedication to mastering new technologies complements a solid foundation in front-end development, allowing me to deliver intuitive and visually captivating user experiences.</span>
                </div>
                <button className="button i-button"><a target={"_blank"} style={{textDecoration: "none"}}
                                                       href="https://www.linkedin.com/in/ozodbek-xayrullayev-a61b0a162/">Hire</a>
                </button>

                <div className="i-icons">
                    <a
                        href="https://github.com/OzodbekX"
                        target="_blank"
                        rel="noreferrer"
                    ><img src={Github} alt=""/></a>

                    <a
                        href="https://au.linkedin.com/in/ozodbek-xayrullayev-a61b0a162/?trk=profile-badge"
                        target="_blank"
                        rel="noreferrer"
                    ><img src={LinkedIn} alt=""/></a>
                    <a
                        href="https://www.instagram.com/ozodbekxayrullayev/"
                        target="_blank"
                        rel="noreferrer"
                    > <img src={Instagram} alt=""/></a>

                </div>

            </div>

            {/* right image side */}
            <div className="i-right">
                <img src={Vector1} alt=""/>
                <img src={Vector2} alt=""/>
                <img className={"me-image"} src={me} alt=""/>
                {/* animation */}
                <motion.img
                    initial={{left: "-36%"}}
                    whileInView={{left: "-24%"}}
                    transition={transition}
                    src={glassesimoji}
                    alt=""
                />

                <motion.div
                    initial={{top: "-4%", left: "74%"}}
                    whileInView={{left: "68%"}}
                    transition={transition}
                    className="floating-div"
                >
                    <FloatinDiv img={crown} text1="Web" text2="Developer"/>
                </motion.div>

                {/* animation */}
                <motion.div
                    initial={{left: "9rem", top: "18rem"}}
                    whileInView={{left: "0rem"}}
                    transition={transition}
                    className="floating-div"
                >
                    {/* floatinDiv mein change hy dark mode ka */}
                    <FloatinDiv img={thumbup} text1="Best Design" text2="Award"/>
                </motion.div>

                <div className="blur" style={{background: "rgb(238 210 255)"}}/>
                <div
                    className="blur"
                    style={{
                        background: "#C1F5FF",
                        top: "17rem",
                        width: "21rem",
                        height: "11rem",
                        left: "-9rem",
                    }}
                />
            </div>
        </div>
    );
};

export default Intro;